module.exports = [{"id":1,"title":"Accounts Manager","location":"Los Angeles","description":"Job Description 1 blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah ","requirements":["requirement1","requirement2","requirement3","requirement4"]},{"id":2,"title":"Sales Representative","location":"Berlin","description":"Job Description 2 blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah ","requirements":["requirement1","requirement2"]}]


//////////////////
// WEBPACK FOOTER
// ./src/components/Jobs/jobs.json
// module id = 609
// module chunks = 0